import React, {useRef} from "react";
import './LoginPage.scss';

export default function LoginPage(props) {
    let emailRef = useRef(null)
    let passwordRef = useRef(null)
    function handleLogin(e) {
        e.preventDefault();
        let forms = document.querySelector('.needs-validation');
        forms.classList.add('was-validated');
        if(emailRef.current.value === 'test@test.com' && passwordRef.current.value==='Ankit01@'){
            props.history.push('/home');
        }
    }

    return (
        <div className='login-page' id='id_login_page'>
            <div className='card'>
                <div className='card-body'>
                   <h4>Login To Continue</h4>
                    <form onSubmit={handleLogin} className="needs-validation">
                        <div className="form-group">
                            <label htmlFor="email">Email:</label>
                            <input ref={emailRef} type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                   className="form-control" id="email" placeholder="abc@example.com"
                                   name="email"  required/>
                                <div className="valid-feedback"></div>
                                <div className="invalid-feedback">Please fill out this field.</div>
                        </div>
                        <div className='form-group'>
                        <label htmlFor="pwd">Password:</label>
                        <input  ref={passwordRef} type="password" id="pwd" name="pwd" className="form-control"
                               placeholder='*****' required={true}
                               pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                               title="Must contain at least one  number and one uppercase and lowercase letter,
                                and at least 8 or more characters"/>
                        </div>
                        <button type="submit" className="btn btn-primary">
                            <div className="bk-btn">
                                <div className="bk-btn-bar"></div>
                                <div className="bk-btn-triangle"></div>
                            </div></button>
                    </form>
                </div>

            </div>
        </div>
    )
}